import React from "react";
import { Box, Stack, Typography, Button, Switch } from "@mui/material";
import { useNavigate } from "react-router";
import axiosInstance from "../../utils/axiosInstance";
import { customersUrl } from "../../utils/urls";
import { Edit } from "@mui/icons-material";
import ServerPaginationDataGrid from "../../components/tables/ServerPaginationDataGrid";
import { toast } from "react-hot-toast";
import PageHeader from "../../components/page-layout/PageHeader";

const Customers = () => {
  const navigate = useNavigate();

  const handleStatusChange = async (userId , currentStatus) => {
    try {
      await axiosInstance.patch(`${customersUrl}/${userId }`, {
        status: !currentStatus,
      });
      toast.success("Status updated successfully");
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Customer Name",
      minWidth: 240,
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      width: 240,
    },
    {
      field: "mobileNumber",
      headerName: "Phone",
      width: 180,
      renderCell: ({ row }) => (
        <Typography>
          {row.mobileNumber
            ? `+91 ${row.mobileNumber.replace(/^(\+91|91)/, "")}`
            : "N/A"}
        </Typography>
      ),
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 150,
    //   renderCell: ({ row }) => (
    //     <Switch
    //       checked={row.status}
    //       onChange={() => handleStatusChange(row.id, row.status)}
    //       color="primary"
    //     />
    //   ),
    // },
    // {
    //   field: "action",
    //   headerName: "Actions",
    //   width: 180,
    //   renderCell: ({ row }) => (
    //     <Button onClick={() => navigate("edit/" + row.id)} startIcon={<Edit />}>
    //       Edit
    //     </Button>
    //   ),
    // },
  ];

  return (
    <Stack spacing={2}>
      <PageHeader
        title={"Customers"}
        lead={
          "Manage your customers, view their details, and update their status from this page."
        }
        buttonTitle={"See Queries"}
        buttonOnClick={() => navigate("/customer-queries")}
        showBack={true}
      />

      <ServerPaginationDataGrid
        url={customersUrl}
        columns={columns}
        name={"customers-table"}
      />
    </Stack>
  );
};

export default Customers;
